import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

import { Notifications } from '@mantine/notifications';
import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, FontScaleProvider, LanguageProvider, ThemeProvider } from '@/contexts';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Top-level providers for the app: routing, auth state, and the
 * theme/Mantine provider (which depends on auth state to load the signed-in
 * user's saved theme preference, so it's nested inside `AuthProvider`).
 */
export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <FontScaleProvider>
            <LanguageProvider>
              <Notifications position="top-center" />
              {children}
            </LanguageProvider>
          </FontScaleProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};
